import React from "react";
import "./AR.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/Ruko Kotwis/Devant/Devant (1).webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281220003574&text=Halo%20Lenny,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Wisata%20(Ruko)%20https://sinarmaskotawisata.id/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="aboutruko" id="ruko">
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
      <div className="containerabout">
        <h1>Our Ruko Commercials</h1>
        <div className="container-desk">
          <div className="desk">
            Ruko Kota Wisata Cibubur merupakan bagian integral dari pengembangan
            kawasan kota mandiri yang dikembangkan oleh Sinar Mas Land. Terletak
            di boulevard utama Kota Wisata, area ruko ini menjadi sentra
            komersial strategis yang menghubungkan hunian, fasilitas umum, dan
            akses transportasi utama.
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Easy Access
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Flexible Rooms
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Strategic Location
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Security 24 Hours
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Modern & Premium Facillities
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
